/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var TrendingDown = createReactComponent("trending-down", "TrendingDown", [["path", { "d": "M15 18h6v-6", "key": "svg-0" }], ["path", { "d": "m3 7 4.443 5.223c.31.365.466.547.658.64a1 1 0 0 0 .546.09c.212-.024.418-.146.83-.39l2.826-1.674c.385-.229.578-.343.778-.37a1 1 0 0 1 .52.068c.187.077.344.237.658.556L21 18", "key": "svg-1" }]]);

export { TrendingDown as default };
//# sourceMappingURL=TrendingDown.js.map
